import styled, { css } from 'styled-components';
import typography from 'src/utils/typography';

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s40};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s24};
    }
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    ${typography.heading.desktop.m};

    @media (max-width: ${theme.sz.md}) {
      ${typography.heading.mobile.m};
    }
  `,
);

export const Text = styled.div(
  () => css`
    ${typography.paragraph.base};
    text-align: center;
  `,
);
